
import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";




const storeApi = (set) => ({
    
    activarTerminado: null,
    activarProductoupdate: null,
    totalProductos: 0,

    setActivarTerminado(valor) {
        set({ activarTerminado: valor });
    },


    setActivarProdUpdate(valor) {
        set({ activarProductoupdate: valor });
    },

    
});




export const useProductosStore = create()(
    devtools(
        persist(storeApi, {
            name: 'productos-store',
            partialize: (state) => ({ activarProductoupdate: state.activarProductoupdate }),
        })
    )
)


